import crossIcon from "../../assets/cross.svg";
import s from "./style.module.scss";

export const CloseButton = ({ onClose }: { onClose: () => void }) => {
  return (
    <button onClick={onClose} className={s.button}>
      <img src={crossIcon} alt="Close" className={s.icon} />
    </button>
  );
};
